module.exports = __webpack_public_path__ + "img/ach.2e05ab55.png";